module.exports = __webpack_public_path__ + "static/media/petrichor.416e493f.jpg";